// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTableCell-head{font-weight:bold;font-size:1rem}.no-wrap{white-space:nowrap}`, "",{"version":3,"sources":["webpack://./src/pages/Table.scss"],"names":[],"mappings":"AAAA,mBACE,gBAAA,CACA,cAAA,CAGF,SACE,kBAAA","sourcesContent":[".MuiTableCell-head {\n  font-weight: bold;\n  font-size: 1.0rem;\n}\n\n.no-wrap {\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
